// Core
import React from 'react';
import { useSelector } from 'react-redux';
import graphColours from 'constants/graphColours';
// Components
import { GeckoRow } from 'ui';
import { Chart } from 'react-google-charts';
import StatsLoader from 'routes/stats/components/StatsLoader';
// Other

const friendlyTypes = {
  live_chat: 'Live Chat',
  twilio: 'SMS',
  mailgun: 'Email',
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'Twitter',
  whatsapp: 'WhatsApp',
  form_response: 'Form Response',
};

const ConversationsByChannelType = (props) => {
  let channelData = [];

  const conversationsByChannel = useSelector(
    (state) => state.statsRoute.conversationsByChannel
  );
  const filteredChannels = useSelector(
    (state) => state.statsRoute.filteredChannels
  );
  const fetchingStats = useSelector(
    (state) => state.statsRoute.fetchingConversationsByChannelStats
  );

  let channelTotals = {
    live_chat: { total: 0, show: false },
    twilio: { total: 0, show: false },
    whatsapp: { total: 0, show: false },
    mailgun: { total: 0, show: false },
    facebook: { total: 0, show: false },
    instagram: { total: 0, show: false },
    twitter: { total: 0, show: false },
    form_response: { total: 0, show: false },
  };

  if (conversationsByChannel.length) {
    conversationsByChannel.forEach((channel) => {
      // Map through, get all that are of each channel type
      // and Add to conversation.
      if (channelTotals[channel.channel_type] === undefined) {
        // Unknown channel types should not be displayed
        return;
      } else {
        channelTotals[channel.channel_type].total += channel.conversation_total;
        channelTotals[channel.channel_type].show = true;
      }
    });
  }

  for (const [key, value] of Object.entries(channelTotals)) {
    // total filter will only apply when there's filtering by channels.
    if (value.show || !filteredChannels.length) {
      if (key !== 'other') {
        channelData.push([friendlyTypes[key], value.total]);
      }
    }
  }

  // Sort so that highest conversation total is furthest left on graph & "other" is always right-most
  channelData = channelData.sort((a, b) => (a[1] > b[1] ? -1 : 1));

  const header = channelData.length
    ? ['Channel Types', 'Conversations']
    : ['date', 'No Channels'];
  const graphData = channelData.length
    ? [header, ...channelData]
    : [header, ['', 0]];

  const options = {
    hAxis: { 
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, color: '#172554' },
      title: 'Channel Types', 
      minValue: 0, 
      slantedText: true,
      gridlines: {
        color: '#CBD5E1',
      },
      baselineColor: '#CBD5E1',
    },
    vAxis: {
      textStyle: { fontName: 'Satoshi-Gecko', italic: false, color: '#172554', fontSize: 11, },
      titleTextStyle: { fontName: 'Satoshi-Gecko', italic: false, bold: true, color: '#172554' },
      title: 'Conversations',
      format: '#,###',
      minValue: 0,
      maxValue: 4,
      gridlines: {
        color: '#CBD5E1',
        count: -1
      },
      baselineColor: '#CBD5E1',
    },
    isStacked: true,
    legend: 'none',
    tooltip: { isHtml: true },
    focusTarget: 'category',
    colors: [graphColours.primary],
  };

  return (
    <div>
      <StatsLoader isLoading={fetchingStats}>
        <GeckoRow>
          <div className="col">
            <Chart
              chartType="ColumnChart"
              data={graphData}
              options={options}
              graph_id={props.id}
              width="100%"
              height="400px"
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
};

export default ConversationsByChannelType;
